// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon-important-active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("styles/img/icon-important-inactive.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("styles/img/icon_close--gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__approve___XqIV9 {
}

.styles__noteContainer___XsW3D {
  margin-top: 7px;
  width: 100%;
}

.styles__rteContainer___P36n2 {
  margin: 20px 0;
}

.styles__readOnlyRichTextEditorContainer___DEBvF {
  margin-top: 7px;
}

.styles__readOnlyRichTextEditor___D0t68 {
  min-height: 60px;
}

.styles__richTextEditor___dJq3U {
  min-height: 120px;
}

.styles__collapseIcon___RbhTJ {
}

.styles__collapseRef___NpFU_ {
}

.styles__collapseRef___NpFU_[data-active='true'] .styles__collapseIcon___RbhTJ {
      transform: rotate(180deg);
    }

.styles__dropdownArea___IYMh0 {
}

.styles__toggleLabel___Siz6W {
}

.styles__formItem___kUt0L textarea {
    min-height: 100px;
  }

.styles__formItem___kUt0L label {
    display: none;
  }

.styles__flexRow___azve1 {
}

.styles__flexSB___zbLwk {
}

.styles__notes___Sx0NN {
  list-style-type: none;
  margin: 0;
  overflow: auto;
  padding: 0;
}

.styles__noteWrapper___dhItB {
  background: white;
  border-left: 4px solid gtYellow;
  padding-left: 0;
}

.styles__richnote___zH9zy {
  padding-bottom: 10px;
  font-weight: 500;
  white-space: pre-wrap;
}

.styles__importantNoteWrapper___q4JYr {
  background: #FDF1ED;
}

.styles__importantNoteWrapper___q4JYr .styles__important___pQyVR {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }

.styles__important___pQyVR,
.styles__remove___SwIFc,
.styles__user____xtNF {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 12px;
}

.styles__title___aIVvz {
  flex: 1;
}

.styles__titleSection___r4VXi {
  position: relative;
}

.styles__titleSection___r4VXi:last-child {
    margin-bottom: 20px;
  }

.styles__titleSection___r4VXi .styles__name___y7vSY {
    transition: all 0.25s;
  }

.styles__titleSection___r4VXi .styles__noName___VAGGm {
    margin-top: 2px;
  }

.styles__user____xtNF {
  text-transform: capitalize;
}

.styles__important___pQyVR {
  margin-right: 15px;
  background-position: center;
  background-size: 13px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  cursor: pointer;
}

.styles__important___pQyVR a {
    display: block;
    box-shadow: none;
    height: 20px;
    width: 20px;
  }

.styles__remove___SwIFc {
  margin-left: 4px;
  background-position: center;
  background-size: 11px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  cursor: pointer;
}

.styles__remove___SwIFc a {
    display: block;
    box-shadow: none;
    height: 100%;
    width: 24px;
  }

.styles__buttons___NKLyk {
  display: flex;
  justify-content: flex-end;
}

.styles__removeBtn___MmZY1 {
}

.styles__cancelBtn___iJSeU {
  margin-left: 14px;
}
`, "",{"version":3,"sources":["webpack://./universal/components/RichNotes/styles.css"],"names":[],"mappings":"AAIA;AAEA;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;AAEA;;AAEA;AAQA;;AAJI;MACE,yBAAyB;IAC3B;;AAIJ;AAEA;;AAEA;AAEA;;AAGE;IACE,iBAAiB;EACnB;;AAEA;IACE,aAAa;EACf;;AAGF;AAEA;;AAEA;AAEA;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,cAAc;EACd,UAAU;AACZ;;AAEA;EAEE,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AAKrB;;AAHE;IACE,yDAA6D;EAC/D;;AAGF;;;EAGE,mDAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EAEE,kBAAkB;AAapB;;AAXE;IACE,mBAAmB;EACrB;;AAEA;IACE,qBAAqB;EACvB;;AAEA;IACE,eAAe;EACjB;;AAGF;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,yDAA+D;EAC/D,eAAe;AAQjB;;AANE;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;AAGF;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,yDAAwD;EACxD,eAAe;AAQjB;;AANE;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;AAGF;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;AAEA;;AAEA;EAEE,iBAAiB;AACnB","sourcesContent":["@value helpers: 'styles/helpers.css';\n@value colors: \"styles/colors.css\";\n@value gtRed, gtGray, textLight from colors;\n\n.approve {\n  composes: button from helpers;\n}\n\n.noteContainer {\n  margin-top: 7px;\n  width: 100%;\n}\n\n.rteContainer {\n  margin: 20px 0;\n}\n\n.readOnlyRichTextEditorContainer {\n  margin-top: 7px;\n}\n\n.readOnlyRichTextEditor {\n  min-height: 60px;\n}\n\n.richTextEditor {\n  min-height: 120px;\n}\n\n.collapseIcon {\n  composes: collapseIcon from helpers;\n}\n\n.collapseRef {\n  composes: collapseRef from helpers;\n\n  &[data-active='true'] {\n    .collapseIcon {\n      transform: rotate(180deg);\n    }\n  }\n}\n\n.dropdownArea {\n  composes: dropdownArea from helpers;\n}\n\n.toggleLabel {\n  composes: toggleLabel from helpers;\n}\n\n.formItem {\n  textarea {\n    min-height: 100px;\n  }\n\n  label {\n    display: none;\n  }\n}\n\n.flexRow {\n  composes: flexRow from helpers;\n}\n\n.flexSB {\n  composes: flexSB from helpers;\n}\n\n.notes {\n  list-style-type: none;\n  margin: 0;\n  overflow: auto;\n  padding: 0;\n}\n\n.noteWrapper {\n  composes: noteWrapper from helpers;\n  background: white;\n  border-left: 4px solid gtYellow;\n  padding-left: 0;\n}\n\n.richnote {\n  padding-bottom: 10px;\n  font-weight: 500;\n  white-space: pre-wrap;\n}\n\n.importantNoteWrapper {\n  background: #FDF1ED;\n\n  .important {\n    background-image: url(\"styles/img/icon-important-active.png\");\n  }\n}\n\n.important,\n.remove,\n.user {\n  color: textLight;\n  font-size: 12px;\n}\n\n.title {\n  flex: 1;\n}\n\n.titleSection {\n  composes: sectionTitle row from helpers;\n  position: relative;\n\n  &:last-child {\n    margin-bottom: 20px;\n  }\n\n  .name {\n    transition: all 0.25s;\n  }\n\n  .noName {\n    margin-top: 2px;\n  }\n}\n\n.user {\n  text-transform: capitalize;\n}\n\n.important {\n  margin-right: 15px;\n  background-position: center;\n  background-size: 13px;\n  background-repeat: no-repeat;\n  background-image: url(\"styles/img/icon-important-inactive.png\");\n  cursor: pointer;\n\n  a {\n    display: block;\n    box-shadow: none;\n    height: 20px;\n    width: 20px;\n  }\n}\n\n.remove {\n  margin-left: 4px;\n  background-position: center;\n  background-size: 11px;\n  background-repeat: no-repeat;\n  background-image: url(\"styles/img/icon_close--gray.png\");\n  cursor: pointer;\n\n  a {\n    display: block;\n    box-shadow: none;\n    height: 100%;\n    width: 24px;\n  }\n}\n\n.buttons {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.removeBtn {\n  composes: buttonDanger from helpers;\n}\n\n.cancelBtn {\n  composes: button from helpers;\n  margin-left: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `'styles/helpers.css'`,
	"colors": `"styles/colors.css"`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"approve": `styles__approve___XqIV9 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"noteContainer": `styles__noteContainer___XsW3D`,
	"rteContainer": `styles__rteContainer___P36n2`,
	"readOnlyRichTextEditorContainer": `styles__readOnlyRichTextEditorContainer___DEBvF`,
	"readOnlyRichTextEditor": `styles__readOnlyRichTextEditor___D0t68`,
	"richTextEditor": `styles__richTextEditor___dJq3U`,
	"collapseIcon": `styles__collapseIcon___RbhTJ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["collapseIcon"]}`,
	"collapseRef": `styles__collapseRef___NpFU_ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["collapseRef"]}`,
	"dropdownArea": `styles__dropdownArea___IYMh0 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["dropdownArea"]}`,
	"toggleLabel": `styles__toggleLabel___Siz6W ${___CSS_LOADER_ICSS_IMPORT_1___.locals["toggleLabel"]}`,
	"formItem": `styles__formItem___kUt0L`,
	"flexRow": `styles__flexRow___azve1 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["flexRow"]}`,
	"flexSB": `styles__flexSB___zbLwk ${___CSS_LOADER_ICSS_IMPORT_1___.locals["flexSB"]}`,
	"notes": `styles__notes___Sx0NN`,
	"noteWrapper": `styles__noteWrapper___dhItB ${___CSS_LOADER_ICSS_IMPORT_1___.locals["noteWrapper"]}`,
	"richnote": `styles__richnote___zH9zy`,
	"importantNoteWrapper": `styles__importantNoteWrapper___q4JYr`,
	"important": `styles__important___pQyVR`,
	"remove": `styles__remove___SwIFc`,
	"user": `styles__user____xtNF`,
	"title": `styles__title___aIVvz`,
	"titleSection": `styles__titleSection___r4VXi ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"name": `styles__name___y7vSY`,
	"noName": `styles__noName___VAGGm`,
	"buttons": `styles__buttons___NKLyk`,
	"removeBtn": `styles__removeBtn___MmZY1 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonDanger"]}`,
	"cancelBtn": `styles__cancelBtn___iJSeU ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`
};
export default ___CSS_LOADER_EXPORT___;
